export enum Routes {
  LOGIN = '/login',
  ADMIN_UI = '/admin_ui',
  UNAUTHORIZED = '/unauthorized',
  SETTINGS = '/settings',
}
